export default __webpack_public_path__ + "static/media/left_arrow.f4720424.svg";